// This file is auto-generated during build process
  // DO NOT EDIT MANUALLY - Changes will be overwritten
  import { Environment } from './environment.model';

  const HOST_URL = 'https://yss-admin.youngstrokeservice.org.au';

  export const environment: Environment = {
    name: 'production',
    production: true,
    sentry_dsn: 'https://4607a8f9f3c14b12888530c90a5fe2c9@o4508515734650880.ingest.us.sentry.io/4504211141427200',
    hostURL: HOST_URL,
    apiURL: `${HOST_URL}/api/v1`,
    cmsApiURL: `${HOST_URL}/spina/api`,
    cmsToken: '4bmsrr65ah3oas5d4sd54st11k',
    GA: 'G-L3EQ0MFSVZ',
    GTM: 'GTM-MSBWV8TQ',
    googleSiteVerification: 'yHhl18PWeOgA2fWeSI-DqGNMRiVjTAJa4sfFrMSipPQ',
  };

  export const PAGE_MAP = {
    'introduction-to-get-involved': 9,
  'introduction-to-get-referral': 10,
  'introduction-for-gps': 11,
  'about-the-program': 12,
  } as const;
  